package fr.manyverse.app.infrastructure.filepicker

import androidx.compose.runtime.Composable
import io.github.vinceglb.filekit.PlatformFile
import io.github.vinceglb.filekit.dialogs.FileKitDialogSettings

/** What a native file picker is opened for. */
enum class PickerContent { Image, Audio }

/**
 * Native dialog settings: on desktop, parented to the app window (modal, kept above it) and
 * titled [title]; on iOS, the Photos representation for images. Default elsewhere.
 */
@Composable
internal expect fun rememberPickerDialogSettings(content: PickerContent, title: String): FileKitDialogSettings

/**
 * Folder the dialog opens in: the user's Pictures / Music folder on desktop. Null for the
 * platform default, and when that folder does not exist.
 */
internal expect fun pickerInitialDirectory(content: PickerContent): PlatformFile?
